import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgTrendUp = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26.25 6.125v7a.875.875 0 1 1-1.75 0V8.237l-9.006 9.007a.876.876 0 0 1-1.238 0L10.5 13.487l-7.256 7.257a.876.876 0 0 1-1.238-1.238L9.88 11.63a.875.875 0 0 1 1.238 0l3.756 3.757L23.263 7h-4.888a.875.875 0 1 1 0-1.75h7a.875.875 0 0 1 .875.875Z" />
  </svg>
);
export default SvgTrendUp;
